import clsx from "clsx";
import ButtonGroup from "@/components/ui/button-group";
import {
  DOCUMENT_SORT_OPTIONS,
  type DocumentSortMode,
} from "@/components/case-checking/documentListSort";

const TOGGLE_LABELS: Record<DocumentSortMode, string> = {
  name: "Name",
  added: "Added",
  document_date: "Date",
};

const SORT_TOGGLE_OPTIONS = DOCUMENT_SORT_OPTIONS.map((opt) => ({
  value: opt.id,
  label: TOGGLE_LABELS[opt.id],
}));

export function DocumentSortToggle({
  value,
  onChange,
  className,
}: {
  value: DocumentSortMode;
  onChange: (next: DocumentSortMode) => void;
  className?: string;
}) {
  return (
    <div
      className={clsx("shrink-0", className)}
      aria-label="Sort documents"
      data-testid="document-sort-toggle"
    >
      <ButtonGroup
        options={SORT_TOGGLE_OPTIONS}
        value={value}
        onChange={onChange}
        size="sm"
        theme="secondary"
        fullWidth={false}
        className="!h-9 !items-stretch !p-0.5 [&_button]:!flex [&_button]:!h-full [&_button]:!items-center [&_button]:!px-2.5 [&_button]:!py-0 [&_button]:!text-xs"
      />
    </div>
  );
}
